import RailsNestedForm from '@stimulus-components/rails-nested-form'

// Connects to data-controller="nested-form"
export default class extends RailsNestedForm {
  connect() {
    super.connect()
  }
}
